import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=d3a531de&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=d3a531de&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3a531de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3a531de')) {
      api.createRecord('d3a531de', component.options)
    } else {
      api.reload('d3a531de', component.options)
    }
    module.hot.accept("./UserInfo.vue?vue&type=template&id=d3a531de&scoped=true", function () {
      api.rerender('d3a531de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userCenter/userList/components/UserInfo.vue"
export default component.exports